<template>
  <div>
    <custom-actions>
      <template #header>
        <el-dropdown @command="handleCommand">
          <el-button type="primary">
            新增<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item, index) of allType" :command="item.value" :key="index">{{ item.label || ''
              }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <!-- 新增：导出按钮 -->
        <el-button v-if="hasExport" type="primary" style="margin-left: 10px;" @click="onDownExcel">导出</el-button>
      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
               label-width="100px">
        <el-form-item label="客户名称" prop="userId">
          <el-select clearable filterable v-model="searchForm.userId" placeholder="请选择客户名称">
            <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工单编号" prop="inventoryCode">
          <el-input placeholder="请输入工单编号" v-model="searchForm.inventoryCode"></el-input>
        </el-form-item>
        <el-form-item label="品种规格" prop="specId">
          <el-select clearable filterable v-model="searchForm.specId" placeholder="请选择品种规格">
            <el-option v-for="(item, index) of specList" :value="item.specId" :label="item.specName"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="记录类型" prop="recordType">
          <el-select :disabled="activeName == '3'" clearable filterable v-model="searchForm.recordType"
            placeholder="请选择记录类型">
            <el-option v-for="(item, index) of recordList[activeName]" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="流程状态" prop="inoutStatus">
          <el-select clearable filterable v-model="searchForm.inoutStatus" placeholder="请选择流程状态">
            <el-option v-for="(item, index) of statusList" :value="item.value" :label="item.label"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="ygDate" label="日期">
          <el-date-picker v-model="dateArr" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" type="daterange"
                          clearable @change="handleDateChange" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="出库" name="1"></el-tab-pane>
        <el-tab-pane label="入库" name="2"></el-tab-pane>
        <el-tab-pane label="调拨" name="3"></el-tab-pane>
      </el-tabs>
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="180" :show-overflow-tooltip="true" label="客户名称" prop="userName"></el-table-column>
        <el-table-column min-width="120" label="工单编号" prop="inventoryCode"></el-table-column>
        <el-table-column min-width="140" label="品种规格" prop="specName"></el-table-column>
        <el-table-column min-width="120" label="是否散油" prop="isBulkOil">
          <template v-slot="{ row }">
            {{ row.isBulkOil == '0' ? '否' : row.isBulkOil == '1' ? '是' : '' }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="记录类型" prop="recordType">
          <template v-slot="{ row }">
            {{ cyRecTypeMap.get(row.recordType) || '' }}
          </template>
        </el-table-column>
        <el-table-column min-width="100" label="流程状态" prop="inoutStatus">
          <template v-slot="{ row }">
            <el-tag v-if="row.inoutStatus == '1'">进行中</el-tag>
            <el-tag v-if="row.inoutStatus == '2'" type="success">已完成</el-tag>
            <el-tag v-if="row.inoutStatus == '3'" type="warning">车辆装运中</el-tag>
          </template>
        </el-table-column>
        <el-table-column min-width="120" v-if="activeName != '3'" label="计划数量" prop="planQuantity"></el-table-column>
        <el-table-column min-width="120" label="实际数量" prop="trueQuantity"></el-table-column>
        <el-table-column min-width="120" v-if="activeName !== '3'" show-overflow-tooltip label="车牌号" prop="vehicleKey"></el-table-column>
        <el-table-column min-width="160" label="关联仓库" prop="ygCode"></el-table-column>
        <el-table-column min-width="160" v-if="activeName == '3'" label="接收仓库" prop="receiveYgCode"></el-table-column>
        <el-table-column min-width="160" v-if="activeName == '3'" label="接收客户" prop="receiveUserName"></el-table-column>
        <el-table-column min-width="160" label="当前节点" prop="nodeName"></el-table-column>
<!--        <el-table-column min-width="100" label="绩效" prop="inoutStatus">-->
<!--          <template v-slot="{ row }">-->
<!--            {{Number(parseFloat(row.trueQuantity * row.jxRatio).toFixed(2))}}-->
<!--          </template>-->
<!--        </el-table-column>-->

        <el-table-column width="200" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="
              $router.push('/cyCrkManage/detail?inventoryId=' + row.inventoryId + '&recordType=' + row.recordType)
              ">详情</el-button>
            <el-button type="text" v-if="row.inoutStatus == '1' && hasApproval" @click="
              $router.push('/cyCrkManage/approval?isApproval=1&inventoryId=' + row.inventoryId + '&recordType=' + row.recordType)
              ">审批</el-button>
            <el-button type="text" v-if="row.inoutStatus == '1' && hasEdit" @click="
              $router.push('/cyCrkManage/edit?inventoryId=' + row.inventoryId + '&recordType=' + row.recordType)
              ">编辑</el-button>
            <el-button type="text" v-if="row.inoutStatus == '1'" class="del-btn"
                       @click="onDelete(row.inventoryId)">删除</el-button>
            <el-button type="text" v-if="row.inoutStatus == '3' && hasComplete"
                       @click="onComplete(row.inventoryId)">完成</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
                     @current-change="loadData">
      </el-pagination>
    </el-card>

    <!-- 审批 -->
    <!-- <ApprovalDialog
      urlType="3"
      :relatedId="rowId"
      v-if="showDlg"
      @closeDlg="showDlg = false"
      @successSave="loadData"
      :showDlg="showDlg"
    ></ApprovalDialog> -->
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
// import ApprovalDialog from '@/views/bondRecord/ApprovalDialog'
import { cyRecType } from '@/utils/dict'
import { mapToObjectArray } from '@/utils/utils'
export default {
  name: 'cyCrkManage',
  mixins: [keepAlive],
  // components: { ApprovalDialog },
  data() {
    return {
      cyRecTypeMap: cyRecType,
      activeName: '1',
      tableData: [],
      specList: [],
      statusList: [
        { label: '进行中', value: '1' },
        { label: '已完成', value: '2' },
        { label: '车辆装运中', value: '3' }
      ],
      page: 1,
      total: 0,
      loading: false,
      dateArr: [],
      searchForm: {
        userId: '',
        inoutStatus: '',
        specId: '',
        recordType: '',
        inventoryCode: '',
        startDate: '',
        endDate: ''
      },
      userList: []
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasApproval() {
      return this.buttonList.includes('approval')
    },
    hasComplete() {
      return this.buttonList.includes('complete')
    },
    // 新增：导出按钮权限
    hasExport() {
      return this.buttonList.includes('export')
    },
    allType() {
      const list = new Map()
      list.set('B4', '租赁入库')
      list.set('A1', '销售出库')
      list.set('A3', '调拨单')
      list.set('A4', '租赁出库')
      return mapToObjectArray(list)
    }
  },
  created() {
    console.log('this.buttonList', this.buttonList)

    this.loadUserList()
    this.loadSpec()
    this.loadData()
  },
  methods: {
    handleDateChange(val) {
      console.log('val', val)
      if (val?.length) {
        this.searchForm.startDate = val[0]
        this.searchForm.endDate = val[1]
      } else {
        this.searchForm.startDate = ''
        this.searchForm.endDate = ''
      }
    },
    onComplete(inventoryId) {
      this.$confirm('确认完成该订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.cyCrkManage.endYgnInoutRecord, {
          inventoryId
        }).then(() => {
          this.loadData()
        })
      })
    },
    handleTabClick() {
      this.searchForm.recordType = ''
      if (this.activeName === '3') {
        this.searchForm.recordType = 'A3'
      }
      this.onSearch()
    },
    onAppoval(row) {
      this.rowId = row.inventoryId
      this.showDlg = true
    },
    loadSpec() {
      this.$axios
        .get(this.$apis.grainSpecifications.selectYxOilSpecByList)
        .then(res => {
          this.specList = res.list || []
        })
    },
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '2'
      }).then(res => {
        this.userList = res.list || []
      })
    },
    handleCommand(command) {
      this.$router.push('/cyCrkManage/add?&recordType=' + command)
    },
    loadData() {
      // inoutType   1入库 2出库
      const inoutType = this.activeName === '1' ? '2' : this.activeName === '2' ? '1' : ''
      const params = {
        page: this.page,
        ...this.searchForm,
        inoutType
      }

      this.$axios
        .get(this.$apis.cyCrkManage.selectYgnInoutRecordByPage, {
          params: params
        })
        .then(res => {
          this.tableData = res.list || []
          this.total = res.total || 0
        })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.formData.resetFields()
      this.onSearch()
    },
    onDelete(inventoryId) {
      this.$confirm('确认删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios
          .post(this.$apis.cyCrkManage.deleteDataYgnInoutRecord, {
            inventoryId
          })
          .then(() => {
            this.loadData()
          })
      })
    },
    // 新增：导出 Excel
    onDownExcel() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      // inoutType 1入库 2出库，与列表查询保持一致
      const inoutType = this.activeName === '1' ? '2' : this.activeName === '2' ? '1' : ''
      this.$axios.post(this.$apis.cyCrkManage.exportYgnInoutRecord, {
        ...this.searchForm,
        inoutType
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const disposition = res.headers['content-disposition']
          const fileName = disposition.substring(disposition.indexOf('filename')).split('=')[1]
          this.downloadFile(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    // 新增：blob 下载
    downloadFile(data, fileName) {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      window.URL.revokeObjectURL(href)
    }
  }
}
</script>

<style scoped lang="scss"></style>
